import React from 'react'
import { Typography } from '@mui/material'
import { useStyles } from './FlyOutProductNotificationCheckbox.styles'
import { CheckBoxFieldv2 } from '@labrav/react-components'
import { notificationCheckboxText } from '../../../common/utils/constants'
import { FormikProps, useFormikContext, FormikHandlers } from 'formik'
import { FormLockedType } from '../../../types/FormLockedType'
import { FlyoutProductSections } from '../../../types/addEditProduct'

export const FlyOutProductNotificationCheckbox: React.FC<FormLockedType> = ({
  isFormLocked,
}) => {
  const { classes } = useStyles()
  const { values, errors, touched, submitCount, handleChange } =
    useFormikContext() as FormikProps<FlyoutProductSections>
  const { generalInformation } = values
  const generalInformationErrors = errors.generalInformation
  const generalInformationTouched = touched.generalInformation

  const handleCheckboxChange =
    (handleChange: FormikHandlers['handleChange']) =>
    (e: React.ChangeEvent<HTMLInputElement>) => {
      handleChange({
        target: {
          name: 'generalInformation.termsAndCondition',
          value: e.target.checked,
        },
      })
    }

  return (
    <div className={classes.rootContainer} data-testid="box-container">
      <div className={classes.description} data-testid="description">
        <Typography>
          <span className={classes.bold}>Disclaimer:</span>{' '}
          {notificationCheckboxText}
        </Typography>
      </div>
      <div className={classes.checkboxContainer} data-testid="checkbox">
        <CheckBoxFieldv2
          keyName="generalInformation.termsAndCondition"
          title="I understand the above disclaimer and agree to it."
          value={generalInformation.termsAndCondition}
          onChangeBox={handleCheckboxChange(handleChange)}
          disabled={isFormLocked}
          isRequired={true}
        />
      </div>
      {!!(
        submitCount > 0 &&
        generalInformationTouched?.termsAndCondition &&
        generalInformationErrors?.termsAndCondition
      ) && (
        <div className={classes.errorMessage}>
          {(!!generalInformationTouched?.termsAndCondition &&
            generalInformationErrors?.termsAndCondition) ||
            (submitCount > 0
              ? generalInformationErrors?.termsAndCondition
              : '')}
        </div>
      )}
    </div>
  )
}
